export default "__VITE_ASSET__CscQ5YZR__"